import Layout from 'components/layout';
import ContentPage from 'components/content-pages';
import { handleContentPageServerSideProps } from 'utils/content-pages';
import { TenantIds, TenantTypes } from 'tenants';
import { FeaturesType } from 'contexts';
import type { GetServerSidePropsContext } from 'next';
import { createGetServerSideProps, type HandlerType } from 'utils/next/shared-getServerSideProps';
import type { ContentPageProps } from 'types/content-pages';
import { Namespaces } from 'types/locales';
import HeadData from 'components/head-data';

const handler: HandlerType<ContentPageProps> = async (_context: GetServerSidePropsContext, _features?: FeaturesType, tenant?: TenantTypes) => {
  return await handleContentPageServerSideProps(tenant.id, [
    TenantIds.EXP_COMMERCIAL,
    TenantIds.EXP_COMMERCIAL_CA,
  ], '/join-us', 'ALL');
};

export const getServerSideProps = createGetServerSideProps(handler, [
  Namespaces.COMMON, // For common buttons and labels
  Namespaces.EXP_COMMERCIAL, // For tenant-specific translations as this page allows EXP_COMMERCIAL
] as const);

export default function BecomeAnAdvisorPage(props: { siteContent: string }) {
  return (
    <Layout showMobileBottomNav={false}>
      <HeadData data={{ title: 'Become an Advisor - eXp Commercial' }} />
      <ContentPage {...props} />
    </Layout>
  );
}
